export default {
  form: {
    amount: {
      label: 'Prix',
    },
    has_sales_based_discount: {
      label: 'Remises basées sur les ventes mensuelles',
    },
  },
  labels: {
    month: 'mois',
    varies_by_tier: 'variable selon le palier',
    max_price: '* Prix maximum : {{amount}}',
    sales_based_discount:
      "jusqu'à +{{threshold}} ventes minimales en un mois. Ensuite, prix normal {{amount}} HT / mois",
  },
  tax: {
    inclusive: '{{taxName}} : {{tax}} (inclus)',
    exclusive: 'par mois plus {{taxName}} : {{tax}}',
  },
  buttons: {
    select: 'Sélectionner',
    save: 'Enregistrer',
    use_default_price: 'Utiliser le prix par défaut',
  },
};
